import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { usePlan } from "@/context/PlanContext";
import AuthGate from "@/components/AuthGate";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Loader2, Lock, Zap } from "lucide-react";
import { PRO_FEATURES } from "@/lib/proFeatures";

export function UpgradeCard({ title = "This is a Pro feature", subtitle, compact = false, testId = "pro-gate" }) {
  const feats = compact ? PRO_FEATURES.slice(0, 4) : PRO_FEATURES;
  return (
    <Card className="bg-[#111723] border-[#222F43] p-8 sm:p-10 relative overflow-hidden" data-testid={testId}>
      <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-emerald-500/10 blur-3xl pointer-events-none" />
      <div className="relative">
        <div className="h-12 w-12 rounded-xl bg-emerald-500/12 flex items-center justify-center mb-4"><Lock className="h-6 w-6 text-emerald-400" /></div>
        <h2 className="font-display text-2xl sm:text-3xl font-extrabold">{title}</h2>
        {subtitle && <p className="text-slate-400 text-sm mt-2 max-w-lg">{subtitle}</p>}
        <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3 mt-6">
          {feats.map((f) => {
            const Icon = f.icon;
            return (
              <li key={f.title} className="flex gap-3 items-start">
                <Icon className="h-4 w-4 text-emerald-400 mt-0.5 shrink-0" />
                <div><div className="text-sm font-semibold">{f.title}</div><div className="text-xs text-slate-400">{f.desc}</div></div>
              </li>
            );
          })}
        </ul>
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 mt-8">
          <Button asChild className="rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0B0F17] font-display font-extrabold px-6">
            <Link to="/pricing" data-testid="upgrade-cta"><Zap className="h-4 w-4 mr-1.5" /> Start 3-day free trial</Link>
          </Button>
          <span className="text-xs text-slate-500 font-mono">$29.99/mo or $250/yr · have a code? redeem it on the pricing page</span>
        </div>
      </div>
    </Card>
  );
}

export default function ProGate({ children, feature }) {
  const { user } = useAuth();
  const { plan, pro } = usePlan();
  return (
    <AuthGate>
      {plan === null && user ? (
        <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-emerald-400" /></div>
      ) : pro ? children : (
        <div className="max-w-3xl mx-auto px-4 py-16">
          <UpgradeCard title={`${feature || "This"} is a Pro feature`} subtitle="Upgrade to unlock it along with unlimited scans and the full Catalyst Calendar." />
        </div>
      )}
    </AuthGate>
  );
}
